import React from 'react';
import InfoHint from './InfoHint';
import './SyntaxHelpPopover.css';

/**
 * Baustein — Syntax-Help-Popover.
 * Info-Trigger neben einem Suchfeld; öffnet einen Popover mit der Liste
 * unterstützter Such-Operatoren. Sitzt typischerweise direkt im
 * `FilterStrip.Search` (help-Slot).
 *
 * Sonderheit: bleibt bei Klick außerhalb OFFEN (InfoHint `persistent`),
 * damit man beim Tippen im Suchfeld mitlesen kann.
 *
 * Verwendung:
 *   <FilterStrip.Search ... help={<SyntaxHelpPopover />} />
 */
const OPERATORS = [
  { key: 'name: / n:', desc: 'Kartenname', example: 'name:Sol Ring' },
  { key: 'oracle: / o:', desc: 'Regeltext', example: 'o:draw' },
  { key: 'type: / t:', desc: 'Typlinie', example: 't:creature' },
  { key: 'keyword: / kw:', desc: 'Keywords', example: 'kw:flying' },
  { key: 'id: / c:', desc: 'Farbidentität', example: 'id:WU' },
  { key: 'pow / tou', desc: 'Stärke / Widerstand, vergleichbar mit =, !=, <, >, <=, >=', example: 'pow>=5 tou<2' },
];

export default function SyntaxHelpPopover() {
  return (
    <InfoHint title="Suchsyntax" persistent triggerLabel="Syntax-Hilfe">
      <p className="syntax-help-intro">
        Operatoren mit Text kombinierbar, z.B. <code>Sol Ring o:draw</code>.
        Mehrere Angaben schränken das Ergebnis weiter ein (UND):
        {' '}<code>t:creature t:legendary</code> findet legendäre Kreaturen.
      </p>
      <table className="syntax-help-table">
        <thead>
          <tr><th>Operator</th><th>Beschreibung</th><th>Beispiel</th></tr>
        </thead>
        <tbody>
          {OPERATORS.map((op) => (
            <tr key={op.key}>
              <td><code>{op.key}</code></td>
              <td>{op.desc}</td>
              <td><code>{op.example}</code></td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="syntax-help-note">Zusammenhängende Ausdrücke in Anführungszeichen: <code>name:"Sol Ring"</code></p>
      <p className="syntax-help-note">
        Bei Stärke-Vergleichen zählen <code>*</code> und <code>X</code> als 0;
        {' '}<code>pow=*</code> bzw. <code>pow=x</code> findet gezielt Karten mit diesem Zeichen.
      </p>
    </InfoHint>
  );
}
